module.exports = __webpack_public_path__ + "img/1473344508.1a463e43.jpg";